import React from 'react';
import styles from './Button.module.css';

export type ButtonVariant = 'primary' | 'brand' | 'secondary' | 'ghost' | 'danger';
export type ButtonSize = 'lg' | 'md' | 'sm';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    /** primary=검정(주 동작) · brand=시안(시간·약속 관련) · secondary=테두리 · ghost=약한 동작 · danger */
    variant?: ButtonVariant;
    size?: ButtonSize;
    /** 가로 full-width */
    block?: boolean;
    /** 좌측 아이콘 — 인라인 SVG 만 (이모지 금지) */
    icon?: React.ReactNode;
}

/**
 * 기본 버튼.
 *
 * 참고 앱 규율: 각진 모서리 · 그림자 없음 · 굵기 700.
 * 주 동작은 브랜드색이 아니라 검정입니다 — 브랜드색은 시간에 씁니다.
 */
export const Button = ({
    variant = 'primary',
    size = 'md',
    block,
    icon,
    children,
    className,
    type = 'button',
    ...rest
}: ButtonProps) => {
    const cls = [
        styles.base,
        styles[size],
        styles[variant],
        block ? styles.block : '',
        className || '',
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <button type={type} className={cls} {...rest}>
            {icon}
            {children}
        </button>
    );
};

/**
 * 화면 하단 고정 버튼 바. 모바일 키보드가 올라오면 기존 --keyboard-offset 을 따라 올라갑니다.
 *
 * 같은 화면에 하단 GNB 가 있으면 aboveGnb 를 켜서 GNB 위로 띄웁니다.
 * (켜지 않으면 GNB 와 같은 자리에 겹칩니다)
 */
export const ButtonFooter = ({
    children,
    aboveGnb,
}: {
    children: React.ReactNode;
    aboveGnb?: boolean;
}) => (
    <div className={aboveGnb ? `${styles.footer} ${styles.footerAboveGnb}` : styles.footer}>
        {children}
    </div>
);
